import React, { useCallback } from 'react';
import { differenceInMinutes } from 'date-fns';
import { Text, Flex, Button } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import TRLoader from './TRLoader';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const EXPECTED_DURATION = 1000 * 60 * 30;
export default function TheftRecoveryLoading(props) {
  const {
    requestMetadata,
    caseData,
    caseActions
  } = props;
  let start;
  const action = requestMetadata.state === 'ending' ? 'Ending' : 'Activating';
  if (requestMetadata.endRequestedAt) {
    start = requestMetadata.endRequestedAt;
  } else {
    start = requestMetadata.createdAt;
  }
  const expectedEnd = start + EXPECTED_DURATION;
  const diff = differenceInMinutes(expectedEnd, Date.now());
  let title = /*#__PURE__*/_jsxs(Text, {
    variant: "sectionTitle",
    children: [action, " Theft Recovery Mode..."]
  });
  let message = null;
  let caseButton = null;
  const onClick = useCallback(() => {
    const id = caseActions.id;
    GlobalState.dispatch(caseActions.parent().goTo(id));
  }, [caseActions]);
  if (diff > 0) {
    message = /*#__PURE__*/_jsx(Text, {
      variant: "caption",
      children: `About ${diff} minutes remaining`
    });
  }
  if (diff < 0) {
    message = /*#__PURE__*/_jsx(Text, {
      variant: "errorCaption",
      children: `Expected ${Math.abs(diff)} minutes ago`
    });
    title = /*#__PURE__*/_jsxs(Text, {
      variant: "sectionTitle",
      children: [action, " Theft Recovery Mode is taking longer than expected"]
    });
  }
  if (diff === 0) {
    message = /*#__PURE__*/_jsx(Text, {
      variant: "caption",
      children: "Expected to complete soon"
    });
  }
  if (caseData) {
    caseButton = /*#__PURE__*/_jsx(Button, {
      onClick: onClick,
      variant: "linkLeftAlign",
      children: `View Case ID ${caseData.data.data.caseId}`
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "rowL",
    align: "center",
    children: [/*#__PURE__*/_jsx(TRLoader, {
      spinning: action === 'Activating'
    }), /*#__PURE__*/_jsxs(Flex, {
      variant: "colM",
      children: [title, message, caseButton]
    })]
  });
}